// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tASC","title":"styles_title__3SHct"};